import React, { useEffect, useState } from "react";
import api from "../lib/api";
import { Button } from "./ui/button";
import { toast } from "sonner";
import { Plus, X } from "lucide-react";

const inp = "h-8 rounded border border-slate-700 bg-slate-800 px-2 text-xs text-slate-100";

export default function AtfSettings() {
  const [rows, setRows] = useState([]);
  const load = () => api.get("/atf-ranges").then((r) => setRows(r.data));
  useEffect(() => { load(); }, []);
  const upd = (i, k, v) => setRows((l) => l.map((r, j) => (j === i ? { ...r, [k]: v } : r)));
  const save = async () => { try { await api.put("/atf-ranges", { data: { ranges: rows } }); toast.success("ATF ZİMMETLERİ KAYDEDİLDİ"); load(); } catch (e) { toast.error(e.response?.data?.detail || "HATA"); } };
  return (
    <div data-testid="atf-settings" className="max-w-3xl rounded-xl border border-slate-800 bg-slate-900 p-4">
      <div className="mb-1 text-sm font-bold text-slate-200">ATF SERİ ZİMMETİ</div>
      <p className="mb-3 text-[11px] text-slate-500">HER ŞUBEYE VERİLEN ATF NUMARA ARALIĞINI GİRİN. KARGO GİRİŞİNDE ATF NO YAZILINCA HANGİ ŞUBEYE ZİMMETLİ OLDUĞU VE DAHA ÖNCE KULLANILIP KULLANILMADIĞI GÖRÜNÜR.</p>
      <table className="w-full text-xs">
        <thead><tr className="text-left text-[10px] text-slate-500"><th className="pb-1">ŞUBE</th><th>BAŞLANGIÇ NO</th><th>BİTİŞ NO</th><th>KULLANILAN / TOPLAM</th><th /></tr></thead>
        <tbody>{rows.map((r, i) => (
          <tr key={i} data-testid={`atf-row-${i}`}>
            <td className="py-0.5 pr-1"><input data-testid={`atf-sube-${i}`} value={r.sube || ""} onChange={(e) => upd(i, "sube", e.target.value.toLocaleUpperCase("tr-TR"))} className={`${inp} w-full`} /></td>
            <td className="pr-1"><input data-testid={`atf-bas-${i}`} value={r.bas || ""} onChange={(e) => upd(i, "bas", e.target.value)} className={`${inp} w-full`} /></td>
            <td className="pr-1"><input data-testid={`atf-son-${i}`} value={r.son || ""} onChange={(e) => upd(i, "son", e.target.value)} className={`${inp} w-full`} /></td>
            <td className="text-slate-300">{r.kullanilan ?? 0} / {Math.max(0, (Number(String(r.son).replace(/\D/g, "")) || 0) - (Number(String(r.bas).replace(/\D/g, "")) || 0) + 1).toLocaleString("tr-TR")}</td>
            <td><button data-testid={`atf-del-${i}`} onClick={() => setRows((l) => l.filter((_, j) => j !== i))} className="text-slate-500 hover:text-rose-400"><X className="h-4 w-4" /></button></td>
          </tr>
        ))}</tbody>
      </table>
      <div className="mt-2 flex gap-2">
        <Button data-testid="atf-add" variant="outline" onClick={() => setRows((l) => [...l, { sube: "", bas: "", son: "" }])} className="h-8 border-slate-700 bg-slate-800 text-xs text-slate-200"><Plus className="mr-1 h-3.5 w-3.5" /> SERİ EKLE</Button>
        <Button data-testid="atf-save" onClick={save} className="h-8 bg-emerald-600 text-xs text-white">KAYDET</Button>
      </div>
    </div>
  );
}
